import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../contexts/AuthContext";
import http from "../http";

export interface CurrentTask {
  id: string;
  dossierKenmerk: string;
  dossierNaam: string;
  taskType: string;
  description?: string;
  lastComment?: string;
  geschatteTijdMinuten?: number;
  startDatum: string;
  vervalDatum?: string;
  isOverdue: boolean;
  assignedByName?: string;
  assignedAt?: string;
  /** All dossier note bodies concatenated for search */
  notities?: string;
}

export const useCurrentTasks = () => {
  const { user } = useAuth();

  return useQuery<CurrentTask[]>({
    queryKey: ["currentTasks", user?.id],
    queryFn: async (): Promise<CurrentTask[]> => {
      const response = await http.get<CurrentTask[]>("/tasks/my-current");
      return response.data;
    },
    enabled: !!user,
    staleTime: 0, // Keep tasks always fresh because assignments are time-sensitive
    gcTime: 0, // Do not cache task data between views
  });
};

export {};
